import React from 'react'
import AuthLeft from '../auth-left/auth-left'
import '../Login/Login.css'
import { Link } from 'react-router-dom'
import Footer from '../../main/footer/footer'

function ForgotPassword() {
  return (
    <div>
      <div className='login-wrapper'>
      <div className="auth-left">
        <AuthLeft />
      </div>
      <div className="auth-right">
        <div className="login-form">
        <div className="flex justify-center mt-[150px] mb-[30px]">
          <h2 className='text-[#04293A] font-extrabold text-[28px]'>DUN'S FARM DASHBOARD</h2>
          </div>
          <h1>Forgot Password</h1>
          <div className="form-section">
            <label>
              Email
              <input 
                type="email" 
                placeholder='Email'
                className='login-input'
              />
            </label>
            <center>
              <Link to='/' className='login-btn'>
                <button className='bg-primary'>Submit</button>
              </Link>
            </center>
          </div>
        </div>
      </div>
    </div>
    <div 
      className="mobile-login"
      // style={{backgroundImage: `url('./images/login/loginBg.webp')`}}
    >
      <img src="./images/auth-bg.png" alt="bg" className='auth-bg' />
      <div className="auth-right">
        <div className="login-form" id='mobile-login-form'>
          <div className="bin-logo-div">
          <h2 className='text-[#04293A] font-extrabold text-[14px]'>DUN'S FARM DASHBOARD</h2>
          </div>
          <h1>Forgot Password</h1>
          <div className="form-section">
            <label>
              Email
              <input 
                type="email" 
                placeholder='Email'
                className='login-input'
              />
            </label>
            <center>
              <Link to='/' className='login-btn'>
                <button className='bg-primary'>Submit</button>
              </Link>
              <p className='text-primary font-bold text-[10px] mt-[20px]'>Go back? {" "}
                <Link to='/' className='text-[#ECB365] underline'>Login</Link>
              </p>
            </center>
            <center>
              <Link to='/dashboard' className='login-btn'>
                <button>Log In</button>
              </Link>
            </center>
          </div>
        </div>
      </div>
    </div>
    <div className=' w-full flex justify-end mt-[-70px] pr-[50px] mobile-footer'>
      <Footer />
    </div>
    </div>
  )
}

export default ForgotPassword;